type WorkforcePatchItem = {
  uid: string;
  role: string;
};

export type JobPatchPayload = {
  status?: string;
  alias?: string | null;
  description?: string | null;
  workforce?: WorkforcePatchItem[];
  isRepetitive?: boolean;
  repetitionalInterval?: string;
  coverageAreaId?: number;
  clientUid?: string;
  scopeOfWorkUrl?: string;
  type?: "basic" | "advanced";
};

/**
 * PATCH /jobs/self/:id only accepts JobUpdateSchema fields.
 * Create payloads (scopeOfWork, eventConfig, type, isVisit, etc.) must not be sent here.
 */
export function buildJobPatchPayload(createPayload: Record<string, unknown>): JobPatchPayload {
  const patch: JobPatchPayload = {};

  if (typeof createPayload.clientUid === "string" && createPayload.clientUid) {
    patch.clientUid = createPayload.clientUid;
  }

  if (createPayload.coverageAreaId != null && createPayload.coverageAreaId !== "") {
    patch.coverageAreaId = Number(createPayload.coverageAreaId);
  }

  if (typeof createPayload.status === "string" && createPayload.status) {
    patch.status = createPayload.status;
  }

  if (createPayload.isRepetitive != null) {
    patch.isRepetitive = Boolean(createPayload.isRepetitive);
  }

  if (typeof createPayload.repetitionalInterval === "string" && createPayload.repetitionalInterval) {
    patch.repetitionalInterval = createPayload.repetitionalInterval;
  }

  if (typeof createPayload.scopeOfWorkUrl === "string" && createPayload.scopeOfWorkUrl) {
    patch.scopeOfWorkUrl = createPayload.scopeOfWorkUrl;
  }

  if (createPayload.type === "basic" || createPayload.type === "advanced") {
    patch.type = createPayload.type;
  }

  if (typeof createPayload.alias === "string") {
    patch.alias = createPayload.alias.trim() || null;
  }

  if (typeof createPayload.description === "string") {
    patch.description = createPayload.description.trim() || null;
  }

  const workforce = createPayload.workforce;
  if (Array.isArray(workforce) && workforce.length > 0) {
    patch.workforce = workforce as WorkforcePatchItem[];
  }

  return patch;
}
